import { z } from "zod";

/**
 * Template variable configuration
 */
export const TemplateVariableSchema = z.object({
  description: z.string(),
  displayName: z.string().optional(),
  isBodyVariable: z.boolean().optional(),
  cardIndex: z.number().optional()
});

export type TemplateVariable = z.infer<typeof TemplateVariableSchema>;
